export default "__VITE_ASSET__CBi0mTGR__"